

import React from 'react';
import type { Author } from '../../types';
import { useTranslation } from 'react-i18next';
import PersonAvatar from '../ui/PersonAvatar';

interface AuthorBioProps {
  author: Author;
}

const AuthorBio: React.FC<AuthorBioProps> = ({ author }) => {
  const { t } = useTranslation('common');
  return (
    <div className="mt-16 pt-8 border-t border-white/10">
      <div className="flex items-start gap-6">
        <div className="flex-shrink-0">
          <PersonAvatar name={author.name} imageUrl={author.imageUrl} className="w-24 h-24 rounded-full" width={96} height={96} />
        </div>
        <div>
          <h3 className="text-xl font-bold font-serif text-white">{t('blogPostPage.aboutAuthor')}</h3>
          <p className="text-lg font-semibold text-white mt-1">{author.name}, <span className="text-white/80">{author.title}</span></p>
          <p className="mt-2 text-white/90 text-sm leading-relaxed">{author.bio}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthorBio;